import { FC } from 'react';
import { NotificationType } from '../../models/NotificationModel';

export const NotificationTypeLabels = {
    [NotificationType.info]: 'お知らせ',
    [NotificationType.maintenance]: 'メンテナンス情報',
    [NotificationType.bug]: '不具合情報',
} satisfies Record<NotificationType, string>;

export interface NotificationLabelProps {
    type: NotificationType;
}

export const NotificationLabel: FC<NotificationLabelProps> = ({ type }) => (
    <>
        <span className="type">{NotificationTypeLabels[type]}</span>
    </>
);
